import MaskedInput, { conformToMask } from 'react-text-mask';
import React, { useState } from 'react';
import InputHelper from '../../helpers/input_helper';
import ValidatedText from './validated_text_input';

const mask = ['(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

export const getConformedValue = (value) => {
  const conformedValue = conformToMask(value, mask, { guide: false });
  return conformedValue.conformedValue;
};

const PhoneFormatInput = ({ onChange, onBlur, name, id, disabled, ...other }) => {
  return (
    <MaskedInput
      {...other}
      id={id}
      name={name}
      mask={['(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
      placeholderChar={'\u2000'}
      onChange={(e) => onChange(generateSyntheticEvent(name, e.target))}
      onBlur={(e) => onBlur(generateSyntheticEvent(name, e.target))}
      onKeyDown={(e) => InputHelper.handleMaskedBackspace(e, '-')}
      guide={false}
      keepCharPositions={false}
      inputMode="numeric"
      disabled={disabled}
      type={'tel'}
    />
  );
};

export const Phone = ({ required, onChange, onBlur, disabled, name, value, id, digits, ...other }) => {
  const [isInvalid, setIsInvalid] = useState('');

  const runValidation = (target) => {
    const value = target.value.replace(/\D/g, ''); //.replace(/[() ]/g, '');

    if (!target.required && (!value || value.length === 0)) {
      if (typeof setIsInvalid === 'function') {
        setIsInvalid(false);
        // } else {
        target.setCustomValidity('');
        target.reportValidity();
      }
    } else if (target.required && (!value || value.length !== 10)) {
      if (typeof setIsInvalid === 'function') {
        setIsInvalid('Phone number must be 10 digits');
        // } else {
        target.setCustomValidity('Phone number must be 10 digits');
      }

      // if (isBlur) {
      //   target.reportValidity();
      // }
    } else {
      if (typeof setIsInvalid === 'function') {
        setIsInvalid(false);
        // } else {
        target.setCustomValidity('');
        target.reportValidity();
      }
    }
  };

  return (
    <ValidatedText
      required={required}
      style={{ width: '100%' }}
      variant="outlined"
      color="primary"
      size={'small'}
      margin={'dense'}
      label="Mobile Phone"
      placeholder={'10 digits only, e.g. 8005551212'}
      disabled={disabled}
      name={name}
      id={name}
      className="input-field"
      value={value}
      onChange={(evt) => {
        runValidation(evt.target);
        onChange(evt);
      }}
      error={!!isInvalid}
      helperText={isInvalid ? isInvalid : ''}
      InputProps={{
        inputComponent: PhoneFormatInput,
        className: 'mui-input',
        disabled,
      }}
      {...other}
    />
  );
};

const generateSyntheticEvent = (name, target) => {
  const value = target.value.replace(/\D/g, ''); //.replace(/[() ]/g, '');

  return {
    maskedValue: target.value,
    unmaskedValue: value,
    target,
    currentTarget: target,
  };
};

export const ExtensionFormatInput = ({ onChange, onBlur, name, id, digits, ...other }) => {
  return (
    <MaskedInput
      {...other}
      id={id}
      name={name}
      mask={[/\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
      placeholderChar={'\u2000'}
      onChange={(e) => onChange(generateSyntheticEvent(name, e.target))}
      onBlur={(e) => onBlur(generateSyntheticEvent(name, e.target))}
      onKeyDown={(e) => InputHelper.handleMaskedBackspace(e, '-')}
      guide={false}
      keepCharPositions={false}
      inputMode="numeric"
    />
  );
};

export default PhoneFormatInput;
